// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"6e7e4032","352":"29662cd4","681":"3142c0c8","901":"3129ca3d","999":"41e3f18b"}[chunkId] + ".chunk.css";
};